
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import axios from 'axios';

// Forcer axios à utiliser l'adapter navigateur
axios.defaults.adapter = require('axios/lib/adapters/xhr');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// ✅ Active le mode offline
serviceWorkerRegistration.register();
